<template>
  <div class='balance' v-if='isNominal'>
    <div class='balance-all'>
      <div class='balance-all-header'>
        <div class='balance-all-header-icon'>₮</div>
        <p style="display:flex; justify-content:space-between; align-items:center; width:100%">{{$t('cashout.type.type1')}}: <router-link :to="{ name: 'nominal-transaction' }" style="font-size:0.75em; margin-left:auto">{{$t('sidebar.history')}}</router-link></p>
      </div>
      <div style="display:flex; flex-direction: row; justify-content: space-between">
        <div class='balance-current'>
          <p class='label'>{{ $t('account.available-balance') }}</p>
          <p class='currency'>
            <masked-amount>
              <template #visible>
                {{ (localBalance ? localBalance.availableBalance : 0) | currency('', '₮') }}
              </template>
            </masked-amount>

            <span class='suffix'> MNT </span>
          </p>
        </div>
        <div class='balance-initial text-right'>
          <p class='label'>{{ $t('account.hold') }}</p>
          <p class='amount'>
            <masked-amount>
              <template #visible>
                {{ (localBalance ? localBalance.hold : 0) | currency('', '₮') }}
              </template>
            </masked-amount>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class='balance' v-else>
    <div class='balance-all' >
      <div class='balance-all-header'>
        <div class='balance-all-header-icon'>₮</div>
        <p style="display:flex; justify-content:space-between; align-items:center; width:100%">{{$t('cashout.type.type2')}}: <span class="iban">{{account}}</span> <router-link :to="{ name: 'mse-transaction' }" style="font-size:0.75em; margin-left:auto">{{$t('sidebar.history')}}</router-link></p>
      </div>
      <div class='balance-current'>
        <p class='label'>{{ $t('account.available-balance') }}</p>
        <p class='currency'>
          <masked-amount>
            <template #visible>
              {{ sum | currency('', '₮') }}
            </template>
          </masked-amount>
          <span class='suffix'> MNT </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MaskedAmount from '../global/MaskedAmount'

export default {
  components: {
    MaskedAmount,
  },
  props: {
    isNominal: {
      type: Boolean,
      default: true,
    },
    account: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    localBalance() {
      return this.$store.getters.localBalance
    },
    remoteBalance() {
      return this.$store.getters.dividends
    },
    mseBalance() {
      return this.$store.getters.mseBalance
    },
    govBondBalance() {
      return this.$store.getters.govBond
    },
    sum() {
      let sum = 0
      // if(this.remoteBalance && Array.isArray(this.remoteBalance) && this.remoteBalance.length)
      //   this.remoteBalance.forEach(item => sum += Number(item.Balance))
      if(this.mseBalance)
        sum += Number(this.mseBalance)
      if(this.remoteBalance)
        sum += Number(this.remoteBalance)
      if(this.govBondBalance)
        sum += Number(this.govBondBalance)
      return sum
    }
  },
  created() {
    if (this.isNominal) {
      this.$store.dispatch('fetchLocalBalance')
    } else {
      this.$store.dispatch('fetchMSEBalance')
    }
  },
}
</script>

<style lang='scss'>
@import './BalanceCard.scss';
</style>
